export default function(e){return void 0===e&&(e=0),new Promise(function(t){return setTimeout(t,e)})}
//# sourceMappingURL=wait.module.js.map
